<script setup lang="ts">
import merge from 'lodash-es/merge';
import type { ListItemModel } from '#layers/elearning/app/pages/elearning/modules/courses/_runtime/services/CourseCategoriesService';
import CourseCategoriesService from '#layers/elearning/app/pages/elearning/modules/courses/_runtime/services/CourseCategoriesService';

defineOptions({
    name: 'WidgetCourseCategoriesSettings'
});

const emit = defineEmits<{
    (e: 'update:modelValue', payload: any): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const defaults = ref<any>({
    categories: []
});

const form = computed<FormType<any>>(() =>
{
    return props.modelValue;
});

const triggetModel = (): void =>
{
    emit('update:modelValue', form.value);
};

const fetchCategory = async (id: any): Promise<ListItemModel> =>
{
    if (id != 0)
    {
        const response = await CourseCategoriesService.fetchAutocompleteModel(id);

        return response || null;
    }

    return null;
};

const searchCategories = async (query: string, limit: number): Promise<ListItemModel[]> =>
{
    if (query.length < 3) return [];

    return await CourseCategoriesService.getAutocompleteList(query, limit);
};

watch(() => form.value.settings, (value: any) =>
{
    triggetModel();
}, { deep: true });

onBeforeMount(async (): Promise<void> =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});
</script>

<template>
    <IdeoFormGroup :label="$t('[[[Kategoria szkolenia]]]')" :invalid-feedback="form.$errors.first('settings.categories')" :state="form.$errors.state('settings.categories')" required>
        <IdeoAutocompleteMultiSelect
            v-model="form.settings.categories"
            name="settings.categories"
            :placeholder="$t('[[[zacznij pisać aby wyszukać kategorię...]]]')"
            :fetch="(id) => fetchCategory(id)"
            :search="(query, limit) => searchCategories(query, limit)"
        >
            <template #selection="{ option }">
                <div class="d-flex flex-nowrap align-items-center">
                    <span v-for="(opt, i) in option" :key="i" class="ms-2 multiselect-badges"><b>{{ opt.name }}</b></span>
                </div>
            </template>
            <template #option="{ option }">
                <div class="d-flex flex-nowrap align-items-center">
                    <b class="ms-2">{{ option.name }}</b>
                </div>
            </template>
        </IdeoAutocompleteMultiSelect>
    </IdeoFormGroup>
</template>
